import React, { useReducer } from 'react';
import CovidEpassTrains from '../route_info/components/CovidEpassTrains';
import {
  BreadCrumb,
  FooterSection
  //   FaqSection
} from '../components';
import { TrainClasses } from '../route_info/TrainClasses';
import { formatDuration, formatDuration2 } from '../../utils/dateTimeFormatUtils';
import DataLoaderError from '../../errors/DataLoaderError';
import { EnvironmentVariables, CovidSpecialTrainsPageData } from '../types';
import { getAppEnv } from '../../../config/env';
import KumbhMelaInfo from './KumbhMelaInfo';
import { searchWidgetInitialState, searchWidgetReducer } from '../../reducers/searchWidgetReducer';
import SearchWidget from '../components/SearchWidget/SearchWidget';
import SEARCH_WIDGET_UTILS from '../components/SearchWidget/utils/utils';
import HtmlHeader from '../components/HtmlHeader';
import { FOOTER_DATA_IRCTC, IRCTC_EXTERNAL_JS } from '../../utils/RailsSEOConstants';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';

const env = getAppEnv();
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;

type KumbhMelaSpecialTrainsPageDataProps = {
  data: CovidSpecialTrainsPageData;
};
const SearchWidgetContext = React.createContext<any>(searchWidgetInitialState);

function decorateListingData(listingData) {
  const { kumbhMelaSpecialTrains } = listingData;

  kumbhMelaSpecialTrains.forEach((train) => {
    // if the current format is in format say 5hr, make it 5hr 0mins
    if (String(train.duration).endsWith('hr')) {
      train.duration = train.duration.concat(' 0mins');
    }
    train.durationFormatted = formatDuration(train.duration);
    train.durationParts = formatDuration2(train.duration.replace('hr ', ':').replace('mins', ''));
  });
  return listingData;
}

const KumbhMelaSpecialTrainsPage = ({ data }: KumbhMelaSpecialTrainsPageDataProps) => {
  const [searchWidgetState, searchWidgetDispatch] = useReducer(searchWidgetReducer, searchWidgetInitialState);
  const { onTrainExtraSectionClicked } = SEARCH_WIDGET_UTILS.KUMBH_MELA_TRAINS(searchWidgetDispatch);
  return (
    <div>
      <SearchWidgetContext.Provider value={{ searchWidgetState, searchWidgetDispatch }}>
        <SearchWidget
          openDatePickerOnMount={false}
          topFix={true}
          classNode={TrainClasses.FC}
          pageWiseContext={SearchWidgetContext}
        />
      </SearchWidgetContext.Provider>
      <div className="container">
        <HtmlHeader data={data} />
        <BreadCrumb breadcrumb={data.template.breadcrumb} />

        <div className="heading">
          <h1 className="appendTop15 appendBottom15 font22">{data.template.h1_title}</h1>
        </div>
        <section>
          <CovidEpassTrains trainsList={data.kumbhMelaSpecialTrains} onClicked={onTrainExtraSectionClicked} />
        </section>
        <section>
          <h2 className="desktopShow font22 latoBold appendBottom15">
            {`Check Out the Kumbh Mela Special Trains - 2025`}
          </h2>
          <KumbhMelaInfo />
        </section>
        {/* <FaqSection
          faq={data.faq}
          pageUrl={data.template.sample_url}
          type="kumbhMelaSpecialTrains"
        /> */}
      </div>
      <FooterSection template={data.template} />
    </div>
  );
};

KumbhMelaSpecialTrainsPage.fetchData = async (_, match, urlObj) => {
  const url = `${DATA_LOADER_URL}/api/getKumbhMelaSpecialTrainsData?refreshMode=static`;

  let responseData;
  const response = await fetch(url);
  // eslint-disable-next-line no-console
  console.info('url', url);
  // eslint-disable-next-line no-console
  console.info('response.status', url, response.status);
  const textResponse = await response.text();
  try {
    responseData = JSON.parse(textResponse);
    // console.log(responseData)
  } catch (e) {
    throw new Error('JSON parse exception: ' + textResponse);
  }
  // eslint-disable-next-line no-console
  console.log('responseData.status', responseData.status);
  if (responseData.status !== 'SUCCESS') {
    throw new DataLoaderError(`Unable to fetch for covid special trains list`, responseData.error);
  }
  responseData.faq = [
    // {
    //   question: `What can you do to stay safe during train travel?`,
    //   answer: `1. Carry masks, wet wipes, gloves and a bottle of sanitizer for quick use.\r\n<br/>\r\n
    //     2. Keep your nose and mouse covered at all times.\r\n<br/>\r\n
    //     3. Clean you hands regularly.\r\n<br/>\r\n
    //     4.. We suggest you to teach the station well in advance, stay calm and help keep others (especially senior citizens and children around you) calm as well.\r\n<br/>\r\n
    //     5. Carry home cooked food and sufficient water for your journey.\r\n<br/>\r\n
    //     6. Download Arogya Setu app on a compatible mobile device.`
    // },
    // {
    //   question: `<div style="color: red;" >How many passengers can I add on a ticket while booking these trains?</div>`,
    //   answer: `You can add up to 6 adult passengers on a single ticket (if it is a general booking). On booking tatkal ticket in special trains, you can add up to 4 adult passengers.`
    // }
  ];
  responseData.infos = [
    // {
    //   query: `Railways to run Festive special trains to clear festive rush`,
    //   info: `Indian Railways has announced around 392 festive special trains to cater to the growing demand during the holiday period of Durga Puja, Dussehra, Diwali and Chhatt puja. These trains will be operational from 20th October 2020 and 30th November 2020. These festive trains will be operated at a speed of 55 kmph.`
    // },
  ];
  responseData.template = {
    pageUrl: `https://www.makemytrip.com/railways/kumbh-mela-special-trains.html`,
    meta_title: `Kumbh Mela 2025 Special Trains for Kumbh Mela – MakeMyTrip`,
    meta_description: ` IRCTC is running Kumbh Mela Special Trains for passengers for Kumbh Mela 2025. There will be several Kumbh Mela 2025 Special trains from various cities. You can book from MakeMyTrip.`,
    meta_keywords: `special train for allahabad kumbh mela, kumbh mela special train time table, special trains for kumbh mela from mumbai, how to go kumbh mela by train, kumbh mela 2024 special trains list, kumbh mela jane ke liye train, kumbh mela special train number, prayagraj kumbh mela train schedule, train to kumbh mela from delhi, kumbh mela special train, kumbh mela special train from mumbai, kumbh mela train booking, kumbh mela train from mumbai, kumbh mela train ticket booking, special train for kumbh mela 2024, allahabad special train kumbh mela, kumbh mela special train from nagpur, kumbh mela special train list, kumbh mela train ticket price, prayagraj kumbh mela special train, special kumbh mela train, train to kumbh mela`,
    analytics: getStaticPageLoadEvent('seo:rails:kumbh mela:trains'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `Kumbh Mela Special Trains`,
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.makemytrip.com/railways/`,
        displayString: `Rails`
      },
      {
        displayString: `Kumbh Mela Special Trains`,
        redirectionUrl: `https://www.makemytrip.com/railways/kumbh-mela-special-trains.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/kumbh-mela-special-trains.html`,
    // sub_title: `Following is the list of all the trains running between Delhi to Mumbai Railway Stations:`,
    // eslint-disable-next-line
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };
  let finalResponse;
  try {
    finalResponse = decorateListingData(responseData);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('err', e);
  }
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_KUMBH-MELA-SPECIAL-TRAINS.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default KumbhMelaSpecialTrainsPage;
